import { Box } from '@mui/material';
import type { KpiResponse } from '~/apis/analyticsApi';
import { KPI_CARD_CONFIGS } from '../kpiConfig';
import { KpiCard } from './KpiCard';

type KpiGridProps = {
  data: KpiResponse | null;
  loading?: boolean;
};

export function KpiGrid({ data, loading = false }: KpiGridProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          lg: 'repeat(4, 1fr)',
          xl: 'repeat(5, 1fr)',
        },
        gap: 2,
      }}
    >
      {KPI_CARD_CONFIGS.map((config) => (
        <KpiCard
          key={config.key}
          config={config}
          data={data}
          loading={loading}
        />
      ))}
    </Box>
  );
}
